export const firebaseConfig = {
    apiKey: "AIzaSyAWiWnPeLOgOaz1aBW1QAY-tMYrgxzZYas",
    authDomain: "react-chat-28bf1.firebaseapp.com",
    databaseURL: "https://react-chat-28bf1.firebaseio.com",
    projectId: "react-chat-28bf1",
    storageBucket: "react-chat-28bf1.appspot.com",
    messagingSenderId: "358186009777",
    appId: "1:358186009777:web:4f0827dda25c1ecae78e90",
    measurementId: "G-6LBWF3E0KG"
};